// extracted by mini-css-extract-plugin
module.exports = {"MathToolsIconButton":"MathToolsIcon_MathToolsIconButton__RvOgo","iconText":"MathToolsIcon_iconText__2F_wq"};